import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncFavorites = Load(
  () =>
    import(
      /* webpackChunkName: "favorites-page" */ './components/FavoritesPage'
    ),
);
const AsyncFavoritesAdd = Load(
  () =>
    import(
      /* webpackChunkName: "favorites-page" */ './components/FavoritesPageAdd'
    ),
);

export const favoritesAddRoute: RouteDescriptor = {
  id: 'favorites.add',
  path: `${basePath}/favorites/add/:experienceId`,
  label: 'Add Favorite Experience',
  audience: 'both',
  layout: 'navigational',
  module: 'favorites',
};

export const favoritesRoute: RouteDescriptor = {
  id: 'favorites.list',
  path: `${basePath}/favorites`,
  label: 'Favorites List',
  audience: 'both',
  layout: 'navigational',
  module: 'favorites',
};

export const favoritesRoutes = [
  createNavigationalRoute({
    key: favoritesAddRoute.id,
    id: favoritesAddRoute.id,
    path: favoritesAddRoute.path,
    component: AsyncFavoritesAdd,
    handle: createRouteHandle(favoritesAddRoute),
    showBottomNavigation: true,
    showSearchInNavbar: true,
    nonFixedNavbar: true,
  }),
  createNavigationalRoute({
    key: favoritesRoute.id,
    id: favoritesRoute.id,
    path: favoritesRoute.path,
    component: AsyncFavorites,
    handle: createRouteHandle(favoritesRoute),
    showBottomNavigation: true,
    showSearchInNavbar: true,
    nonFixedNavbar: true,
  }),
];

export const favoritesRouteDescriptors = [favoritesAddRoute, favoritesRoute];

export default favoritesRoutes;
